import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({ name: 'fromNow' })
export class FromNowPipe implements PipeTransform {

  /**
   * @param date in format 'DD-MM-YYYY HH:mm'
   * @returns humanized duration as example: "3 minutes from now"
   */
  transform(date: string): string {
    return moment(date).fromNow();
  }
}
